export default function getLocalization(stringKey) {
  if (typeof window.kaislakujanpaa_screenReaderText === 'undefined' || typeof window.kaislakujanpaa_screenReaderText[stringKey] === 'undefined') {
    // eslint-disable-next-line no-console
    console.error(`Missing translation for ${stringKey}`);
    return '';
  }
  return window.kaislakujanpaa_screenReaderText[stringKey];
}
